export {
  SCALES, TONLEITER_STUFEN, skalaVon, skalaTonklassen, skalenNach,
} from './scales';
export type { ScaleDef } from './scales';
export { ARPEGGIO_FINGER, arpeggioPitchClasses } from './arpeggios';

export interface NoteDef {
  key: string;
  acc?: string | null;
}

const PITCH_CLASS: Readonly<Record<string, number>> = {
  c: 0,
  'c#': 1,
  db: 1,
  d: 2,
  'd#': 3,
  eb: 3,
  e: 4,
  f: 5,
  'f#': 6,
  gb: 6,
  g: 7,
  'g#': 8,
  ab: 8,
  a: 9,
  'a#': 10,
  bb: 10,
  b: 11,
};

export function noteDefToMidi(note: NoteDef): number {
  const [notePart, octaveText] = note.key.split('/');
  return (Number.parseInt(octaveText, 10) + 1) * 12 + (PITCH_CLASS[notePart] ?? 0);
}

export interface SequenceRun {
  index: number;
  lastMidi: number | null;
  errors: number;
}

export function advanceSequence(
  run: SequenceRun,
  midi: number,
  expectedPitchClasses: ReadonlyArray<number>,
): Readonly<SequenceRun> {
  const expected = expectedPitchClasses[run.index];
  const pitchClass = ((midi % 12) + 12) % 12;
  const ascending = run.index === 0
    || (run.lastMidi !== null && midi > run.lastMidi);
  if (pitchClass === expected && ascending) {
    return Object.freeze({
      index: run.index + 1,
      lastMidi: midi,
      errors: run.errors,
    });
  }

  const startsAgain = pitchClass === expectedPitchClasses[0];
  return Object.freeze({
    index: startsAgain ? 1 : 0,
    lastMidi: startsAgain ? midi : null,
    errors: run.errors + 1,
  });
}

export function raiseOctave(note: NoteDef): NoteDef {
  const [notePart, octaveText] = note.key.split('/');
  return { ...note, key: `${notePart}/${Number.parseInt(octaveText, 10) + 1}` };
}

export function invertVoicing(
  notes: ReadonlyArray<NoteDef>,
  inversion: number,
): NoteDef[] {
  const sorted = [...notes].sort((a, b) => noteDefToMidi(a) - noteDefToMidi(b));
  if (!sorted.length) return sorted;
  const steps = ((Math.trunc(inversion) % sorted.length) + sorted.length) % sorted.length;
  for (let i = 0; i < steps; i++) {
    sorted.push(raiseOctave(sorted.shift() as NoteDef));
  }
  return sorted;
}
